import { AcumaticaRequestOptions, AcumaticaService } from '../acumatica.service';
import { AcumaticaEntity, AcumaticaEntityService } from './acumatica-entity';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Acumatica, AcumaticaFieldFormat } from '../acumatica-field-decorator';

@Injectable({
    providedIn: 'root'
})
export class ItemPriceLookupService extends AcumaticaEntityService {
    constructor(acumatica: AcumaticaService) {
        super(acumatica, 'ItemPriceLookup', ItemPriceLookup);
    }

    get(InventoryID: string, CustomerID: string | null, options: AcumaticaRequestOptions = {}): Observable<ItemPriceLookup> {
        let inquiry = new ItemPriceLookup();
        inquiry.InventoryID = InventoryID;
        inquiry.CustomerID = CustomerID;

        return super.putEntity(inquiry, {
            ...{ message: "Getting Item Pricing" },
            ...options,
        });
    }

    getAsOf(AsOfDate: Date, InventoryID: string, CustomerID: string | null, options: AcumaticaRequestOptions = {}): Observable<ItemPriceLookup> {
        let inquiry = new ItemPriceLookup();
        inquiry.InventoryID = InventoryID;
        inquiry.CustomerID = CustomerID;
        inquiry.PriceDate = AsOfDate;

        return super.putEntity(inquiry, {
            ...{ message: "Getting Item Pricing" },
            ...options,
        });
    }
}

export class ItemPriceLookup extends AcumaticaEntity {
    @Acumatica() InventoryID!: string;
    @Acumatica() CustomerID: string | null = null;
    @Acumatica() PriceDate: Date | null = null;
    @Acumatica({write:false}) CustomerPrice: string | null = null;
    @Acumatica({write:false}) LevelPrice: string | null = null;
    @Acumatica({write:false}) TariffRate: string | null = null;

    constructor(init?: any) {
        super(init);
    }
}